var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({ref:"field",attrs:{"value":_vm.value},nativeOn:{"paste":function($event){return _vm.handlePaste.apply(null, arguments)}}},'v-text-field',_vm.inputAttrs,false),_vm.forwardedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }